import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { UiModule } from '../shared/ui/ui.module';
import { WidgetModule } from '../shared/widget/widget.module';

import { PagesRoutingModule } from './pages-routing.module';
import { SimplebarAngularModule } from 'simplebar-angular';
import { NgbNavModule, NgbDropdownModule, NgbTooltipModule } from '@ng-bootstrap/ng-bootstrap';
import { NgApexchartsModule } from 'ng-apexcharts';
import { NgPipesModule } from 'ngx-pipes';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { TableModule } from 'primeng/table';
import { InputTextModule } from 'primeng/inputtext';
import { DropdownModule } from 'primeng/dropdown';
import { CalendarModule } from 'primeng/calendar';
import { SharedModule } from '../shared/shared.module';

import { DashboardComponent } from './dashboard/dashboard.component';
import { AccountComponent } from './account/account.component';
import { ApiIntegrationComponent } from './api-integration/api-integration.component';
import { BillingComponent } from './billing/billing.component';
import { TemplatesComponent } from './templates/templates.component';
import { ImageCropperComponent } from 'ngx-image-cropper';
import { AddTemplateComponent } from './templates/add-template/add-template.component';
import { S3StorageComponent } from './s3-storage/s3-storage.component';
import { ESignModule } from './e-sign/e-sign.module';
import { EStampModule } from './e-stamp/e-stamp.module';

@NgModule({
  declarations: [
    DashboardComponent,
    AccountComponent,
    ApiIntegrationComponent,
    BillingComponent,
    TemplatesComponent,
    AddTemplateComponent,
    S3StorageComponent,
  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    PagesRoutingModule,
    UiModule,
    NgPipesModule,
    NgbNavModule,
    NgbDropdownModule,
    NgbTooltipModule,
    NgApexchartsModule,
    SimplebarAngularModule,
    SharedModule,
    ImageCropperComponent,
    DragDropModule,
    TableModule,
    InputTextModule,
    DropdownModule,
    CalendarModule,
    ESignModule,
    EStampModule
  ],
  providers: [
  ]
})
export class PagesModule { }
